mutation requestReward($taskId: Int!) {
  requestReward(taskId: $taskId) {
    ok
    achievement {
      baseAchievement {
        id
        name
        propsContent {
          id
          title
          type
          props
          images {
            id
            compressedImage {
              webp {
                lg
                md
                sm
                xl
                xs
              }
            }
          }
        }
      }
      currentAchievement {
        id
        name
        repeatable
        achievementLevel
        propsContent {
          id
          title
          type
          props
          images {
            id
            compressedImage {
              webp {
                lg
                md
                sm
                xl
                xs
              }
            }
          }
        }
        category {
          id
          name
        }
        userTask {
          id
          amount
          isCompleted
          target
          rewardClaimed
        }
        condition {
          id
          type
          hasProgressBar
          providersList {
            objId
            name
            code
          }
          gamesList {
            edges {
              node {
                id
                name
                image
              }
            }
          }
          conditionSettings {
            id
            gameGroupFilter {
              id
              conditionId
              filterGames {
                type
                value
              }
            }
            quantitativeSettings {
              id
              amount1
              amount2
              amount3
              currency {
                code
                name
                objId
                region
              }
            }
            bettingFilters {
              id
              minOdd
              type
            }
          }
        }
        actions {
          id
          type
          program
          freespinCount
          freespinSettings {
            freespinCount
            duration
            game {
              name
            }
            betByCurrency {
              betId
              denomination
            }
          }
          bettingBonusSettings {
            sumByUserCurrency
          }
          quantitativeSettings {
            id
            amount1
            amount2
            amount3
            currency {
              code
              name
              objId
              region
            }
          }
        }
      }
      nextAchievement
    }
  }
}
